export let rThen = (r) => {
    if(r === null){

        return null;

    } else{
        return r;
    }
}